"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Education$ = exports.Education$outboundSchema = exports.Education$inboundSchema = void 0;
exports.educationToJSON = educationToJSON;
exports.educationFromJSON = educationFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const schoolitem_js_1 = require("./schoolitem.js");
/** @internal */
exports.Education$inboundSchema = z.object({
    all_through: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    independent: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    nursery: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    post_16: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    primary: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    pupil_referral_units: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    secondary: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    special: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
    universities: z.nullable(z.array(schoolitem_js_1.SchoolItem$inboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "all_through": "allThrough",
        "post_16": "post16",
        "pupil_referral_units": "pupilReferralUnits",
    });
});
/** @internal */
exports.Education$outboundSchema = z.object({
    allThrough: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    independent: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    nursery: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    post16: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    primary: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    pupilReferralUnits: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    secondary: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    special: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
    universities: z.nullable(z.array(schoolitem_js_1.SchoolItem$outboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        allThrough: "all_through",
        post16: "post_16",
        pupilReferralUnits: "pupil_referral_units",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Education$;
(function (Education$) {
    /** @deprecated use `Education$inboundSchema` instead. */
    Education$.inboundSchema = exports.Education$inboundSchema;
    /** @deprecated use `Education$outboundSchema` instead. */
    Education$.outboundSchema = exports.Education$outboundSchema;
})(Education$ || (exports.Education$ = Education$ = {}));
function educationToJSON(education) {
    return JSON.stringify(exports.Education$outboundSchema.parse(education));
}
function educationFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Education$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Education' from JSON`);
}
//# sourceMappingURL=education.js.map